import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '../Services/translate.service';

@Pipe({ standalone: false, name: 'translate' })
export class TranslatePipe implements PipeTransform {
	constructor(private translateService: TranslateService) {}
	transform(value, ...args: any[]) {
		if (typeof args[0] === 'undefined') return this.translateService.get(value);
		return this.translateService.get(value, args[0]);
	}
}

@Pipe({ standalone: false, name: 'translateAllowEmpty' })
export class TranslateAllowEmptyPipe {
	constructor(private translateService: TranslateService) {}
	transform(value, ...args: any[]) {
		if (typeof args[0] === 'undefined') return this.translateService.get(value, null, true);
		return this.translateService.get(value, args[0], true);
	}
}
